import { NotebookPenIcon } from 'lucide-react';

/**
 * A note that logs a Termin/visit ("Termin protokolliert …") — the icon legend's
 * Interaktion/Protokoll glyph, distinct from the plain NoteIcon.
 */
export const LoggedNoteIcon = NotebookPenIcon;
